import { DeepPartial } from "react-hook-form"

import { Logger } from "shared/lib/Logger"
import { Room } from "shared/types/Room"

import z from "zod"

import { RoomSchemaTransform } from "../types/Room"

export function getRoomComplete(
  room: DeepPartial<Room>
): Required<Room> | undefined {
  const completeRoom: Required<Room> | undefined = z.safeParse(
    RoomSchemaTransform,
    room
  ).data

  if (!completeRoom) {
    Logger.error(
      "ValidationError",
      "unable to create optimistic response while creating room"
    )
  }

  return completeRoom
}
